import { firestoreService } from '@/utils/firestoreService'
import { gitRef } from '@/utils/version'

export interface DeployedVersion {
  sha: string
  deployedAt: number
  branch?: string
}

export interface VersionCheckResult {
  currentVersion: string
  deployedVersion: string | null
  matches: boolean
  deployedAt?: number
  branch?: string
}

/**
 * Check if the current app version matches the deployed version in Firestore
 * @returns Version check result with comparison details
 */
export async function checkVersion(): Promise<VersionCheckResult> {
  try {
    // Explicitly pass undefined as tenantId to ensure global access (not tenant-scoped)
    const deployed = await firestoreService.get<DeployedVersion>('app_config', 'version', undefined)
    console.log('version check', deployed)

    const currentVersion = gitRef
    const deployedVersion = deployed?.sha || null

    return {
      currentVersion,
      deployedVersion,
      matches: currentVersion === deployedVersion,
      deployedAt: deployed?.deployedAt,
      branch: deployed?.branch,
    }
  } catch (error) {
    console.error('Failed to check version:', error)
    // If version check fails, assume versions match to avoid false warnings
    return {
      currentVersion: gitRef,
      deployedVersion: null,
      matches: true,
    }
  }
}
